var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
var INITIAL_STATE = {
    values: { program: '' },
    options: { program: [] },
    loadingLevel: '',
    error: '',
};
var cascadeReducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case 'reset':
            return INITIAL_STATE;
        case 'select':
            return __assign(__assign({}, state), { values: __assign(__assign({}, state.values), (_a = {}, _a[action.level] = action.value, _a)) });
        case 'loading':
            return __assign(__assign({}, state), { loadingLevel: action.level, error: '' });
        case 'loaded':
            return __assign(__assign({}, state), { options: __assign(__assign({}, state.options), (_b = {}, _b[action.level] = action.options, _b)), error: action.error, loadingLevel: state.loadingLevel === action.level ? '' : state.loadingLevel });
        case 'error':
            return __assign(__assign({}, state), { error: action.error, loadingLevel: '' });
        default:
            return state;
    }
};
export var useLookupCascade = function () {
    var _a = React.useReducer(cascadeReducer, INITIAL_STATE), state = _a[0], dispatch = _a[1];
    var stateRef = React.useRef(state);
    stateRef.current = state;
    var requestIdsRef = React.useRef({});
    var reset = React.useCallback(function () {
        requestIdsRef.current = {};
        dispatch({ type: 'reset' });
    }, []);
    var select = React.useCallback(function (level, value) {
        dispatch({ type: 'select', level: level, value: value });
    }, []);
    var setError = React.useCallback(function (error) {
        dispatch({ type: 'error', error: error });
    }, []);
    var load = React.useCallback(function (level, lookup) { return __awaiter(void 0, void 0, void 0, function () {
        var requestId, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestId = ((_a = requestIdsRef.current[level]) !== null && _a !== void 0 ? _a : 0) + 1;
                    requestIdsRef.current[level] = requestId;
                    dispatch({ type: 'loading', level: level });
                    return [4, lookup()];
                case 1:
                    result = _b.sent();
                    if (requestIdsRef.current[level] !== requestId) {
                        return [2, []];
                    }
                    dispatch({
                        type: 'loaded',
                        level: level,
                        options: result.options,
                        error: result.errorMessage,
                    });
                    return [2, result.options];
            }
        });
    }); }, []);
    var getSelectedOption = React.useCallback(function (level, value) {
        var selectedValue = value !== null && value !== void 0 ? value : stateRef.current.values[level];
        var levelOptions = stateRef.current.options[level];
        return levelOptions.find(function (option) { return String(option.value) === selectedValue; });
    }, []);
    var getSelectedLabel = React.useCallback(function (level) { var _a, _b; return (_b = (_a = getSelectedOption(level)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''; }, [getSelectedOption]);
    return __assign(__assign({}, state), { reset: reset, select: select, load: load, setError: setError, getSelectedOption: getSelectedOption, getSelectedLabel: getSelectedLabel });
};
